<template>
  <div>
    <com-dialog :visible.sync="visible" width="40%" title="修复异常提现单">
      <el-alert
        title="请先确认商户侧老退款单未到账，再执行修复。修复后该提现单会打回待审核，仅补退剩余未到账金额。"
        type="warning"
        :closable="false"
        show-icon
      />
      <el-descriptions class="mt-15px" title="提现信息" :column="1">
        <el-descriptions-item label="订单编号">{{ info.number }}</el-descriptions-item>
        <el-descriptions-item label="提现金额">{{ info.amount }}</el-descriptions-item>
        <el-descriptions-item label="应到账金额">{{ info.reviceSum }}</el-descriptions-item>
        <el-descriptions-item label="已退款金额">{{ info.successRefundPrice }}</el-descriptions-item>
        <el-descriptions-item label="剩余待退款金额">{{ info.surplusRefundPrice }}</el-descriptions-item>
        <el-descriptions-item label="退款进度">{{ info.refundProgressText }}</el-descriptions-item>
      </el-descriptions>
      <div class="flex items-center justify-end mt-20px">
        <el-button @click="close">取消</el-button>
        <el-button type="warning" @click="submit" :loading="loading">{{ loading ? '修复中' : '确认修复' }}</el-button>
      </div>
      <com-checked-pwd ref="checkPwd" @confirm="handleConfirm" />
    </com-dialog>
  </div>
</template>

<script>
import { userWithdrawRepairApi } from '@/api/finance'
import utils from 'my-tools-library'

export default {
  data() {
    return {
      visible: false,
      loading: false,
      info: {}
    }
  },
  methods: {
    open(opt) {
      const { row } = opt
      this.info = utils.deepCopy(row)
      this.visible = true
    },
    close() {
      this.visible = false
    },
    submit() {
      this.$refs.checkPwd.open()
    },
    handleConfirm(val) {
      const params = {
        userWithdrawCode: this.info.code,
        auditPassword: val
      }
      this.loading = true
      userWithdrawRepairApi(params).then((res) => {
        if (res.status === 200) {
          this.$message.success('修复成功')
          this.$emit('success')
          this.close()
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
